import React, { useState } from 'react';

interface SubscriptionDropdownProps {
    currentSubscription: string;
    onChange: (newSubscription: string) => void;
}

const SubscriptionDropdown: React.FC<SubscriptionDropdownProps> = ({ currentSubscription, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isSubOpen, setIsSubOpen] = useState(false);

    const handleSelection = (type: string) => {
        console.log(`Selected subscription: ${type}`);

        if (type === 'inactive') {
            onChange('inactive');
        } else {
            onChange(type);
        }

        setIsOpen(false);
        setIsSubOpen(false);
    };


    return (
        <div className="relative inline-block text-left">
            <button
                className="px-4 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-200"
                onClick={() => setIsOpen(!isOpen)}
            >
                {currentSubscription || 'Select Subscription'}
            </button>

            {isOpen && (
                <div className="absolute left-0 mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-50">
                    <button
                        className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                        {currentSubscription}
                    </button>

                    <div
                        className="relative"
                        onMouseEnter={() => setIsSubOpen(true)}
                        onMouseLeave={() => setIsSubOpen(false)}
                    >
                        <button className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                            Subscription Grant ▶
                        </button>

                        {isSubOpen && (
                            <div className="absolute left-full top-0 mt-[-2px] w-32 bg-white border border-gray-300 rounded-md shadow-lg">
                                <button
                                    className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                    onClick={() => handleSelection('monthly')}
                                >
                                    Free 1 month
                                </button>
                                <button
                                    className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                    onClick={() => handleSelection('yearly')}
                                >
                                    Free 1 year
                                </button>
                            </div>
                        )}
                    </div>

                    {currentSubscription !== 'Inactive' && (
                        <button
                            className="block w-full px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                            onClick={() => handleSelection('inactive')}
                        >
                            Inactive
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default SubscriptionDropdown;
